var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li>\n        <ui-icon icon=\"film\"></ui-icon>\n        "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"genre") : depth0), depth0)) != null ? stack1 : "")
    + "\n      </li>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li>\n        <ui-icon icon=\"alarm\"></ui-icon>\n        "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"length_hours") : depth0), depth0))
    + "h\n        "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"length_minutes") : depth0), depth0))
    + "m\n      </li>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <ui-icon\n        icon=\"fsk-badge-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"fsk") : depth0), depth0))
    + "\"\n        size=\"auto\"\n        title=\"FSK "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"fsk") : depth0), depth0))
    + "\"\n        viewBox=\"0 0 500 156\"\n      ></ui-icon>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "      <ui-icon\n        icon=\"fsk-badge-unknown\"\n        size=\"auto\"\n        title=\"FSK (noch) unbekannt\"\n        viewBox=\"0 0 500 156\"\n      ></ui-icon>\n";
},"9":function(container,depth0,helpers,partials,data) {
    return " *";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"fsk") : depth0),0,{"name":"compare","hash":{"operator":">"},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":6},"end":{"line":47,"column":18}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"descriptor") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":39,"column":8},"end":{"line":46,"column":15}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <details>\n            <summary>Deskriptoren</summary>\n            <span>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"descriptor") : depth0), depth0))
    + "</span>\n          </details>\n";
},"15":function(container,depth0,helpers,partials,data) {
    return "          Deskriptoren (noch) unbekannt\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"fsk") : depth0),12,{"name":"compare","hash":{"operator":"=="},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":51,"column":4},"end":{"line":53,"column":16}}})) != null ? stack1 : "");
},"18":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"parental-guidance\" title=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"getParentalGuidance") || (depth0 != null ? lookupProperty(depth0,"getParentalGuidance") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"getParentalGuidance","hash":{},"data":data,"loc":{"start":{"line":52,"column":44},"end":{"line":52,"column":67}}}) : helper)))
    + "\">* "
    + alias4(((helper = (helper = lookupProperty(helpers,"getParentalGuidance") || (depth0 != null ? lookupProperty(depth0,"getParentalGuidance") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"getParentalGuidance","hash":{},"data":data,"loc":{"start":{"line":52,"column":71},"end":{"line":52,"column":94}}}) : helper)))
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"movie-attributes\">\n  <ul>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"genre") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":8,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"length_hours") : depth0),0,{"name":"compare","hash":{"operator":">"},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":15,"column":16}}})) != null ? stack1 : "")
    + "  </ul>\n</div>\n\n<div class=\"fsk-holder\">\n  <div class=\"fsk-holder__top\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"fsk") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":21,"column":4},"end":{"line":35,"column":11}}})) != null ? stack1 : "")
    + "    "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"fsk") : depth0),12,{"name":"compare","hash":{"operator":"=="},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":4},"end":{"line":36,"column":56}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"fsk") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":4},"end":{"line":48,"column":11}}})) != null ? stack1 : "")
    + "  </div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"fsk") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":50,"column":2},"end":{"line":54,"column":9}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});